import React from 'react';
import { CopyLinkButton } from '../guide/CopyLinkButton';
import { ValidationBadge } from './ValidationBadge';
import type { ValidationStatus } from '../../types/progression';

/** Apartado de una guía interactiva, con ancla compartible. */
export function GuidePanel({
  id,
  eyebrow,
  title,
  children
}: {
  id: string;
  eyebrow?: string;
  title: string;
  children: React.ReactNode;
}) {
  return <section id={id} aria-labelledby={`${id}-t`} className="scroll-mt-24 md:scroll-mt-32" data-id="element-818" data-mp="1oslm2u5a82ei">
      <div className="flex items-start justify-between gap-3" data-id="element-819" data-mp="1ju0h6hf34ujq">
        <div className="min-w-0" data-id="element-820" data-mp="1jvlbq71egdhl">
          {eyebrow && <p className="text-xs font-semibold text-[#D4AF37] md:text-sm" data-id="element-821" data-mp="1yrkjfgklkbm7">{eyebrow}</p>}
          <h2 id={`${id}-t`} className="mt-0.5 font-cinzel text-xl font-bold text-white md:text-3xl" data-id="element-822" data-mp="1ts7wywxn16k5">{title}</h2>
        </div>
        <CopyLinkButton hash={id} iconOnly label="Copiar enlace a este apartado" data-id="element-823" data-mp="3a5eshdkzyisf" />
      </div>
      <div className="mt-4 space-y-4" data-id="element-824" data-mp="357whzirbzvib">{children}</div>
    </section>;
}
export type Fact = {
  label: string;
  value: string;
  status?: ValidationStatus;
};

/** Datos clave (nivel, NPC, coste…) con su estado de validación. */
export function FactList({
  facts
}: {
  facts: Fact[];
}) {
  return <dl className="grid gap-2 sm:grid-cols-2" data-id="element-825" data-mp="6wwjq8j5ywxm">
      {facts.map(f => <div key={f.label} className="rounded-2xl border border-white/10 bg-[#0A1628] p-3" data-id="element-826" data-mp="az17iqmxkzcc">
          <dt className="text-xs text-gray-400" data-id="element-827" data-mp="awot2ngdt741">{f.label}</dt>
          <dd className="mt-0.5 text-sm font-semibold text-white" data-id="element-828" data-mp="3afpru5t6atke">{f.value}</dd>
          {f.status && <dd className="mt-1.5" data-id="element-829" data-mp="3fe138kz49c4q"><ValidationBadge status={f.status} data-id="element-830" data-mp="3fdhi6ve667mh" /></dd>}
        </div>)}
    </dl>;
}

/** Subtítulo dentro de un apartado. */
export function SubHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="pt-2 font-cinzel text-base font-bold text-white md:text-lg" data-id="element-831" data-mp="3o7nv4007dv8n">{children}</h3>;
}

/** Aviso destacado. */
export function Note({
  tone = 'info',
  children
}: {
  tone?: 'info' | 'warn';
  children: React.ReactNode;
}) {
  return <div className={`rounded-2xl border p-3.5 text-sm leading-relaxed ${tone === 'warn' ? 'border-amber-300/30 bg-amber-300/[0.06] text-amber-50' : 'border-sky-300/20 bg-sky-300/[0.05] text-gray-200'}`} data-id="element-832" data-mp="2u8hjzeu0ub7">
      {children}
    </div>;
}